import { cn } from "@/lib/utils";

const MAP = {
  filed: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  approved: "bg-cyan-500/10 text-cyan-400 border-cyan-500/30",
  pending_approval: "bg-amber-500/10 text-amber-400 border-amber-500/30 pulse-glow",
  saved_to_portal: "bg-sky-500/10 text-sky-400 border-sky-500/30",
  prepared: "bg-indigo-500/10 text-indigo-400 border-indigo-500/30",
  draft: "bg-slate-500/10 text-slate-400 border-slate-500/30",
  not_started: "bg-slate-500/5 text-slate-400 border-slate-500/20",
  matched: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  mismatch: "bg-rose-500/10 text-rose-400 border-rose-500/30",
  missing_in_books: "bg-yellow-500/10 text-yellow-400 border-yellow-500/30",
  missing_in_2b: "bg-purple-500/10 text-purple-400 border-purple-500/30",
};

const LABEL = {
  filed: "Filed",
  approved: "Approved",
  pending_approval: "Pending Approval",
  saved_to_portal: "Saved to Portal",
  prepared: "Prepared",
  draft: "Draft",
  not_started: "Not started",
};

export function StatusBadge({ status, className, testid }) {
  return (
    <span
      data-testid={testid}
      className={cn(
        "inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-mono uppercase tracking-wider whitespace-nowrap",
        MAP[status] || MAP.draft,
        className
      )}
    >
      {LABEL[status] || (status ? status.replace(/_/g, " ") : "—")}
    </span>
  );
}
